import React from 'react';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';

const CarsSearchMask = ({cor, preflang, prefcurrency}) => {
  const url = `//www.rentalcars.com/partners/integrations/stand-alone-app/?affiliateCode=airticketsgr&
cor=${cor}&preflang=${preflang}&prefcurrency=${prefcurrency}&fts=true&enableReturnCheckbox=true&
css=true&adplat=homepage&adcamp=cartab&affUrl=cars.airtickets.com`;
  return (
    <div className="carsSearchMask">
      <Iframe
        url={url}
        position="absolute"
        width="100%"
        height="100%"
        frameBorder="0"
        scrolling="no"
      />
    </div>
  );
};

CarsSearchMask.propTypes = {
  cor: PropTypes.string.isRequired,
  preflang: PropTypes.string.isRequired,
  prefcurrency: PropTypes.string.isRequired
};

export default CarsSearchMask;
